import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import { SocialShare } from "@quintype/components";
import { StickySocialShareTemplate } from "./../sticky-social-share";
import { StoryHeader } from "../story-header";
import { AuthorDetails } from "../author-details";
import { StoryCardStack } from "../story-card-stack";
import { StoryTags } from "../story-tag";
import { MostPopular } from "../most-popular";
import PropTypes from "prop-types";
import { MetypeCommentWrapper } from "../../metype-comments";
import { DfpAd } from "../../dfp-ad/";
import humanizeDate from "../../utils/time-format";
import { EngagementCount } from "../../basic/engagement-count";
import { DFPAdsHorizontal } from "../../dfp-ad-horizontal";
import { ViqeoEmbed } from "../viqeo-embed";
import AlsoWatch from "../also-watch";
import TaboolaAd from "../../taboola-ad";
import "./styles.m.css";

export class BlankStoryTemplate extends React.Component {
  constructor() {
    super();
    this.state = {
      renderMetype: false,
      renderColombia: false
    };
  }
  componentDidMount() {
    this.setState({
      renderMetype: true
    });
  }

  render() {
    const author = {
      name: get(this.props.story, ["authors", 0, "name"], this.props.story["author-name"]),
      id: get(this.props.story, ["authors", 0, "id"], this.props.story["author-id"]),
      twitter: get(this.props.story, ["authors", 0, "twitter-handle"]),
      avatarUrl: get(this.props.story, ["authors", 0, "avatar-url"]),
      slug: get(this.props.story, ["authors", 0, "slug"]),
      "avatar-s3-key": get(this.props.story, ["authors", 0, "avatar-s3-key"])
    };

    return (
      <div styleName="blankstory">
        <div>
          <StoryHeader story={this.props.story} showHeroImage />
          <div styleName="story-body">
            <SocialShare
              template={StickySocialShareTemplate}
              title={this.props.story.headline}
              url={this.props.story.slug}
              color="#fff"
              sticky
            />
            <div styleName="story-content">
              <div styleName="author-wrapper">
                <div>
                  <AuthorDetails
                    author={author}
                    storyFirstPublishedDate={this.props.story["first-published-at"]}
                    storyLastPublishedDate={this.props.story["last-published-at"]}
                  />
                </div>
                <EngagementCount storyId={this.props.story.id} />
              </div>
              <StoryCardStack story={this.props.story} />
              {this.props.story.metadata &&
                this.props.story.metadata["reference-url"] && (
                  <div styleName="news-else-where">
                    <a
                      styleName="readmore-btn"
                      rel="noopener noreferrer"
                      target="_blank"
                      href={this.props.story.metadata["reference-url"]}
                    >
                      {" "}
                      {this.props.publisherAttributes.lang === "ur"
                        ? "مزید پڑھیں"
                        : this.props.publisherAttributes.lang === "hi"
                          ? "और देखें"
                          : "Read More"}
                    </a>
                  </div>
                )}
              <ViqeoEmbed />
              <StoryTags tags={this.props.story.tags} />
              <span>
                {this.props.story["first-published-at"] !== this.props.story["last-published-at"]
                  ? `Published: ${humanizeDate(this.props.story["first-published-at"])}`
                  : null}
              </span>
              {/* <ViqeoEmbed /> */}
            </div>
          </div>
          <DFPAdsHorizontal />
          {this.state.renderMetype && (
            <MetypeCommentWrapper metypeConfig={this.props.metypeConfig} story={this.props.story} />
          )}
          <AlsoWatch />
          <TaboolaAd />
        </div>
        <div>
          <div styleName="dfp">
            <DfpAd adtype="NH_300x250" />
          </div>
          <MostPopular mostPopular={this.props.mostPopular} id={this.props.story.id} hideIcon />
          <div styleName="dfp">
            <DfpAd adtype="NH_MP_300x600" />
          </div>
        </div>
      </div>
    );
  }
}

function BlankStoryBase(props) {
  return (
    <div className="story-grid">
      <BlankStoryTemplate
        story={props.story}
        mostPopular={props.mostPopular}
        metypeConfig={props.metypeConfig}
        publisherAttributes={props.publisherAttributes}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
}

export const BlankStory = connect(
  mapStateToProps,
  null
)(BlankStoryBase);

BlankStoryTemplate.propTypes = {
  mostPopular: PropTypes.Array,
  story: PropTypes.object,
  metypeConfig: PropTypes.object,
  publisherAttributes: PropTypes.object
};
BlankStoryBase.propTypes = {
  story: PropTypes.object,
  mostPopular: PropTypes.Array,
  metypeConfig: PropTypes.object,
  publisherAttributes: PropTypes.object
};
